import { IIconProps } from "../types"

export default function IconUL1(props: IIconProps) {
  const width = props.size || props.width || 73
  const height = props.size || props.height || 92
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 73 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.0863 0.824674C33.9363 0.984674 32.0563 1.37467 29.8663 2.19467C27.6863 3.00467 25.2163 4.24467 22.8763 6.09467C20.5263 7.95467 18.3163 10.4247 15.7063 16.0947C13.1063 21.7547 10.1163 30.6147 7.9263 37.5747C5.7463 44.5447 4.3863 49.6247 3.3363 54.4747C2.2963 59.3247 1.5863 63.9447 1.1563 67.8847C0.736303 71.8247 0.606303 75.0747 0.936303 77.8747C1.2563 80.6747 2.0363 83.0147 2.8863 84.7147C3.7363 86.4047 4.6463 87.4447 6.3663 88.2247C8.0963 89.0047 10.6363 89.5247 15.0263 89.8847C19.4263 90.2447 25.6763 90.4447 32.8363 90.2147C39.9963 89.9847 48.0663 89.3347 53.6363 88.6147C59.1963 87.9047 62.2563 87.1247 64.4363 85.9847C66.6263 84.8447 67.9263 83.3447 68.9663 81.2647C70.0063 79.1747 70.7863 76.5047 71.1763 73.2247C71.5663 69.9347 71.5663 66.0247 71.0463 61.0447C70.5263 56.0647 69.4863 50.0147 67.9263 43.0747C66.3663 36.1447 64.2763 28.3347 62.5563 22.8947C60.8263 17.4547 59.4563 14.3947 57.7663 11.7347C56.0763 9.06467 54.0563 6.78467 51.5463 5.02467C49.0463 3.26467 46.0463 2.02467 43.3463 1.37467C40.6463 0.724674 38.2363 0.664674 36.0863 0.824674Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
